import React from 'react';

/* eslint-disable */
const Takeaway = ({ body }) => {
    return (
        <div className="main-content-body-inner-container">
            <div className="main-content-body-title">
                Takeaway
            </div>
            <div className="main-content-text-container main-content-body-scrollable-box">
                <div>
                SAME SAME IS CURRENTLY OPERATING FOR TAKEAWAY ONLY, PLEASE SEE BELOW OUR TAKEAWAY MENU.
                </div>
                <br />
                <div>
                TO PLACE YOUR ORDER CALL US FROM 12PM (THUR-SUN) OR 3PM (MON-WED) ON <a href="tel:0731881418"><u>(07) 3188 1418</u></a>. IF THE LINE IS BUSY,
PLEASE EMAIL <a href="mailto:seatme@samesamerestaurant.com.au"><u>SEATME@SAMESAMERESTAURANT.COM.AU</u></a> WITH YOUR CONTACT DETAILS AND WE WILL CALL YOU RIGHT BACK.
                </div>
                <br />
                <div>
                PLEASE NOTE WE DO REQUIRE PAYMENT AT TIME OF ORDERING.
                </div>
                <br />
                <div>
                <a href="/SAME_SAME_TAKEAWAY_MENU.pdf" target="_blank"><u>VIEW TAKEAWAY MENU</u></a>
                </div>
            </div>
        </div>
    );
};

export default Takeaway;



// WEBPACK FOOTER //
// ./src/Theme/Takeaway.jsx